<div
  class="combo-bubble-anchor"
  *ngIf="visible"
  [style.left.px]="cardLeft"
  [style.top.px]="cardTop"
>
  <div class="combo-bubble-card" [style.max-width.px]="maxCardWidth">
    <!-- Header: layer icon + big value + unit + × -->
    <div class="cb-header">
      <span class="cb-layer-icon" [style.color]="accent">
        <!-- sst: thermostat -->
        <svg *ngIf="layerIconKey(state.config.layer) === 'sst'" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a3 3 0 0 0-3 3v8.1A5 5 0 1 0 15 13.1V5a3 3 0 0 0-3-3zm0 2a1 1 0 0 1 1 1v9.3l.5.3a3 3 0 1 1-3 0l.5-.3V5a1 1 0 0 1 1-1z"/></svg>
        <!-- chl: leaf -->
        <svg *ngIf="layerIconKey(state.config.layer) === 'chl'" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17 8C8 10 5.9 16.2 4 22l1.7-.5C7 17 9 14.5 12 13c0 0-3 4-3 7 5-1 9-5 11-11 1-3 1-7 1-7s-4 0-7 1z"/></svg>
        <!-- wind: air -->
        <svg *ngIf="layerIconKey(state.config.layer) === 'wind'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 8h11a2.5 2.5 0 1 0-2.5-2.5M3 16h13a2.5 2.5 0 1 1-2.5 2.5M3 12h7a2 2 0 1 0-2-2"/></svg>
      </span>
      <span class="cb-value" [style.color]="accent">{{ valueText }}</span>
      <span class="cb-unit">{{ unitText }}</span>
      <button type="button" class="cb-close" (click)="onClose()" aria-label="Dismiss">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6B7785" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
    </div>

    <div class="cb-divider"></div>

    <!-- lat/lon -->
    <div class="cb-latlon">{{ latLonLabel }}</div>

    <!-- Wind-at-point row -->
    <div class="cb-wind-row">
      <span class="cb-wind-arrow" [style.opacity]="windOpacity" [style.transform]="'rotate(' + windArrowDeg + 'deg)'">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#6B7785"><path d="M12 2l7 18-7-4-7 4z"/></svg>
      </span>
      <span class="cb-wind-spd">{{ windSpeedText }}</span>
      <span class="cb-wind-dir">{{ windDirText }}</span>
    </div>

    <!-- Level-2 affordance -->
    <button type="button" class="cb-models" (click)="onOpenModels()" [style.opacity]="modelsEnabled ? 1 : 0.4">
      <span [style.color]="accent">compare models</span>
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" [attr.stroke]="accent" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
    </button>
  </div>
  <div class="combo-bubble-tail"></div>
</div>
